import html2pdf from 'html2pdf.js'

import {
  buildPrintTemplateHtmlDocument,
  resolvePrintTemplate,
} from '@/services/printing/printTemplateService'
import { renderPrintTemplateBody } from '@/services/printing/printTemplateRenderer'

function normalizeFileName(value, fallback = 'ticket') {
  const normalized = String(value || fallback)
    .trim()
    .toLowerCase()
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '-')
  return normalized || fallback
}

function buildPdfHostMarkup(template, bodyHtml) {
  const hostClass = 'ticket-pdf-host'
  const rawCss = String(template?.css_template || '')
  const scopedCss = rawCss
    .replace(/html,\s*body/g, `.${hostClass}`)
    .replace(/\bbody\b/g, `.${hostClass}`)

  return [
    `<style>${scopedCss}</style>`,
    `<div class="${hostClass}">${String(bodyHtml || '')}</div>`,
  ].join('')
}

export async function renderTicketHtmlDocument(payload, options = {}) {
  const resolution = await resolvePrintTemplate(payload?.template_key || 'account', {
    channel: payload?.channel || 'shared',
    templateFormat: payload?.template_format || 'html',
    timeoutMs: options.timeoutMs,
    strictOnline: options.strictOnline,
  })

  if (!resolution?.template) {
    throw new Error('No hay una plantilla publicada o en cache para generar el ticket.')
  }

  const bodyHtml = renderPrintTemplateBody(resolution.template.html_template, payload || {})
  const documentHtml = buildPrintTemplateHtmlDocument(resolution.template, bodyHtml, {
    title: options.title || payload?.document?.title || resolution.template.label || 'ticket',
  })

  return {
    template: resolution.template,
    source: resolution.source,
    bodyHtml,
    documentHtml,
  }
}

export async function downloadTicketPdf(payload, options = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false
  }

  const { template, bodyHtml } = await renderTicketHtmlDocument(payload, options)
  const container = document.createElement('div')
  container.style.position = 'fixed'
  container.style.left = '0'
  container.style.top = '0'
  container.style.opacity = '0'
  container.style.pointerEvents = 'none'
  container.style.overflow = 'hidden'
  container.style.width = `${Number(template.paper_width_mm || 80)}mm`
  container.style.background = '#ffffff'
  container.style.zIndex = '-1'
  container.setAttribute('aria-hidden', 'true')
  container.innerHTML = buildPdfHostMarkup(template, bodyHtml)
  document.body.appendChild(container)

  try {
    await html2pdf()
      .set({
        filename: `${normalizeFileName(options.fileName || payload?.document?.title || 'ticket')}.pdf`,
        margin: 0,
        pagebreak: { mode: ['css', 'legacy'] },
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
        },
        jsPDF: {
          unit: 'mm',
          format: [Number(template.paper_width_mm || 80), Number(template.page_height_mm || 297)],
          orientation: 'portrait',
        },
      })
      .from(container)
      .save()

    return true
  } finally {
    container.remove()
  }
}
